import { nextTick } from "vue";
import { createI18n } from "vue-i18n";

export type SupportedLocale = 'fr-CA' | 'en-CA' | 'en-US' | 'fr-FR' | 'it-IT' | 'nl-BE' | 'fr-BE';
export const supportedLanguages = [
    { locale: 'en-CA', name: 'Canada - English' },
    { locale: 'fr-CA', name: 'Canada - Français' },
    { locale: 'fr-FR', name: 'France & International - Français' },
    { locale: 'en-US', name: 'US & International - English' },
    { locale: 'it-IT', name: 'Italiano' },
    { locale: 'nl-BE', name: 'Vlaams' },
    { locale: 'fr-BE', name: 'Belgique - Français' },
] as { locale: SupportedLocale, name: string }[];
export const supportedLocales = supportedLanguages.map((language) => language.locale);

export const fallbackLocale = 'en-US';

const i18n = createI18n({
    globalInjection: true,
    legacy: false,
    allowComposition: true,
    locale: "fr-FR",
    fallbackLocale: fallbackLocale,
    warnHtmlMessage: false,
    warnHtmlInMessage: 'off',
});

export const setI18nLanguage = async (lang: string) => {
    lang = lang.replace('_', '-');
    if (!supportedLocales.includes(lang as SupportedLocale)) {
        lang = fallbackLocale;
    }
    i18n.global.locale.value = lang;
    document.querySelector('html')?.setAttribute('lang', lang);
    await loadLocaleMessages(lang);
};

export const loadLocaleMessages = async (locale: string) => {
    const messages = await import(`@/public/vue/Plugins/locales/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages.default);

    return nextTick();
};

export default i18n;